import { Box, Button, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";

const SUPPORT_EMAIL = "care@shipinsure.io";

function buildSupportMailto(claimNumber) {
  const subject = encodeURIComponent(`Help with claim ${claimNumber}`);
  const body = encodeURIComponent(
    `Hi,\n\nI need help with claim ${claimNumber}.\n\n`,
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}

export function MerchantSupportCard({
  merchant,
  claimNumber,
  isAwaitingReview,
  t,
}) {
  const supportHref = buildSupportMailto(claimNumber);

  return (
    <Box
      sx={{
        border: "1px solid #C5D0E0",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#F8FAFC",
        mb: 0,
      }}
    >
      <Typography
        component="h2"
        fontWeight={700}
        fontSize="1.1rem"
        color={baseTheme.colors.text}
        mb="8px"
      >
        {t("status.merchant.title")}
      </Typography>
      <Typography fontSize="14px" color="#1E293B" mb="12px">
        {t("status.supportReplyExpectation")}
      </Typography>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        flexWrap="wrap"
        gap="10px"
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <Button
          variant="contained"
          href={supportHref}
          size="large"
          sx={{
            textTransform: "none",
            fontWeight: 700,
            fontSize: "15px",
            px: 3,
            py: 1.25,
            minHeight: 48,
          }}
        >
          {t("status.contactSupport")}
        </Button>
        {merchant?.domain_url && !isAwaitingReview ? (
          <Button
            variant="outlined"
            href={merchant.domain_url}
            target="_blank"
            rel="noreferrer"
            size="large"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "15px",
              minHeight: 48,
            }}
          >
            {t("status.shopAgain")}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
}
